import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { FaCheckCircle, FaLeaf, FaTruck } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./WorntoWow.css";
import AOS from "aos";
import "aos/dist/aos.css";
// Custom Arrows
const PrevArrow = ({ onClick }) => (
    <div className="arrow prev" onClick={onClick}>
        <FaChevronCircleLeft />
    </div>
);
const NextArrow = ({ onClick }) => (
    <div className="arrow next" onClick={onClick}>
        <FaChevronCircleRight />
    </div>
);
const reviews = [
    {
        text: "https://5asec.ae/wp-content/uploads/2025/10/Artboard-1.jpg"
    },
    {
        text: "/Artboard-2.webp"
    },
    {
        text: "/Artboard-5.webp"
    },
    {
        text: "/Artboard-10.webp"
    },
    {
        text: "/Artboard-11.webp"
    },
    ,
    {
        text: "/Artboard-12.webp"
    },
    ,
    {
        text: "/Artboard-14.webp"
    },
    ,
    {
        text: "/Artboard-13.webp"
    },

];

export default function WorntoWow() {
    const [play, setPlay] = useState(false);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200, // small laptop
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768, // tablet
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
             {
        breakpoint: 576, // For phones
        settings: {
          slidesToShow: 1, // Show 1 slide for phones
          slidesToScroll: 1,
        },
      },
        ],
    };


    useEffect(() => {
        AOS.init({
            duration: 1200,
            easing: "ease-in-out",
            once: true,
            offset: 80,
        });
    }, []);
    return (
        <div className="slider-wrapper">
            <div className="row">
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                    <div className="worntoWow-wrapper">
                        <h2 className="expertise-title">From Worn to Wow
                        </h2>
                        <p>Professional shoe cleaning and restoration services that bring the shine back.

                        </p>
                        <Slider {...settings}>
                            {reviews.map((item, index) => (
                                <div key={index}>
                                    <div className="worntoWow-box" data-aos="zoom-in-down">
                                        <span className="review-text">
                                            <img src={item.text} alt="" style={{ width: "100%", height: "250px" }} />
                                        </span>


                                    </div>
                                </div>
                            ))}
                        </Slider>

                    </div>

                </div>

                <div className="col-sm-1"></div>

            </div>







        </div>
    );
}
